import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { HelmetProvider } from 'react-helmet-async';
render(<HelmetProvider data-id="element-382">
    <App data-id="element-383" />
  </HelmetProvider>, document.getElementById('root'));